import { DailyScheduleEntryVM } from '../../../services/schedulers/types';

export interface ISchedulerEvent {
  id: string,
  title: any,
  startTime: any,
  endTime: any,
  daysOfWeek: number[],
  backgroundColor: string,
  color: string,
  weekday: number,
}

//////////////////////////////////////////////////////////////////////////
// CONVERT 
//////////////////////////////////////////////////////////////////////////
export function convertWeeklySchedule(weeklySchedule: DailyScheduleEntryVM[] | undefined, theme: any, daysOfWeek?: any[] | undefined): ISchedulerEvent[] {

  const entries = weeklySchedule?.map((item: DailyScheduleEntryVM, index) => {
    return {
      id: `${item.weekday}_${index}`,
      title: item.value,
      startTime: new Date(item.start).toTimeString(),
      endTime: new Date(item.end).toTimeString(),
      daysOfWeek: daysOfWeek ?? [item.weekday],
      backgroundColor: theme.colors.backgroundLightAccent,
      color: theme.colors.accent,
      weekday: item.weekday,
    }
  })
  return entries ?? [];
}


export function toEvent(dayNumber: number, timeFrom: Date, timeTo: Date, value: any, index: number, theme: any): ISchedulerEvent {

  return {
    id: `${dayNumber}_${index}`,
    title: value,
    startTime: new Date(timeFrom).toTimeString(),
    endTime: new Date(timeTo).toTimeString(),
    backgroundColor: theme.colors.backgroundLightAccent,
    color: theme.colors.accent,
    weekday: dayNumber,
    daysOfWeek: [dayNumber]
  }
}


//////////////////////////////////////////////////////////////////////////
// CONVERT BACK
//////////////////////////////////////////////////////////////////////////
export function convertWeeklyScheduleBack(events: ISchedulerEvent[]): DailyScheduleEntryVM[] {
  
  return events.map((elm : ISchedulerEvent, index) => {
    const now = new Date();
    // we need a unspecific date time!
    const start = elm.startTime.slice(0,elm.startTime.indexOf(' '));
    const end = elm.endTime.slice(0,elm.endTime.indexOf(' '));
    return {
      start: `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}T${start}`, 
      end: `${now.getFullYear()}-${now.getMonth()+1}-${now.getDate()}T${end}`,
      value: elm.title,
      weekday: elm.weekday
    }
  });
}